import React from 'react';

import ErrorMessage from '../components/ErrorMessage';

const ErrorPage = () => {
	return (
		<ErrorMessage message = "This page does not exist" />
	);
};

export default ErrorPage;